import { round2, parseImporte } from '@/utils/money';
import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  EuroOutlined,
  BeachAccess,
  RemoveRedEye,
  Euro,
  MonetizationOn,
  MonetizationOnOutlined,
} from '@material-ui/icons';
import { LoadingButton } from '@mui/lab';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useFormStyles } from '../../styles/formStyles';
import { validationSchemaSupplierService } from '../../utils/schemaValidationForm';
import Autocomplete from '@mui/material/Autocomplete';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { startExchangeRateToSupplier, startNewService } from '../../redux/actions/supplierServices';
import { Box } from '@mui/system';
import { startLogOutContentModal } from '../../redux/actions/contentModal';
import { uiManageModalCollectionTypes } from '../../redux/actions/ui';
import { calculateFromDollarsToEuro } from '../../utils/utils';
import { startLoadingSuppliers } from '../../redux/actions/suppliers';
import { obtenerPrecioDolares, obtenerPrecioEuros } from '../../utils/exchange';
import { SwitchMUI } from '../ui/Switch';

export const ContentModalServiceSupplierAdd = () => {
  const classes = useFormStyles(); //the classes variable to handle the form styles
  const dispatch = useDispatch();
  const [value, setValue] = useState('');
  const [serviceType, setServiceType] = useState('');
  const [showReemplazarNombre, setShowReemplazarNombre] = useState(false);
  const { rate } = useSelector(state => state.service);
  const { active, suppliers } = useSelector(state => state.supplier);
  const { error } = useSelector(state => state.ui);

  const initialValues = {
    proveedor: active ? active.PkProveedores : '',
    tipo_servicio: '',
    Nombre: '',
    Alias: '',
    CosteDolares: '',
    PrecioVentaEuros: '',
    TasaDolares: '',
    PaginaWeb: '',
    Observaciones: '',
    ServicioFueraUE: active?.ProveedorFueraUE ?? false,
    TransporteAlojamiento: active?.ProveedorFueraUE ?? false,
    ReemplazarNombreProveedor: active?.ReemplazarNombreProveedor ?? false,
  };
  useEffect(() => {
    if (active?.ReemplazarNombreProveedor) {
      setShowReemplazarNombre(true);
    }
  }, [active]);
  useEffect(() => {
    if (!active) dispatch(startLoadingSuppliers());
  }, [active, dispatch]);
  useEffect(() => {
    if (!active && value && serviceType) {
      dispatch(startExchangeRateToSupplier(value, serviceType));
    } else if (active && serviceType) {
      dispatch(startExchangeRateToSupplier(active.PkProveedores, serviceType));
    }
  }, [value, serviceType, dispatch, active]);

  const handleSubmit = (values, { setSubmitting }) => {
    const service = {
      FkTiposServicio: values.tipo_servicio,
      FkProveedores: values.proveedor,
      Nombre: values.Nombre,
      Alias: values.Alias,
      CosteDolares: round2(parseImporte(values.CosteDolares)),
      TasaDolares: round2(parseImporte(values.TasaDolares)),
      PrecioVentaEuros: round2(parseImporte(values.PrecioVentaEuros)),
      //"ReservaEuros": values['PrecioVentaEuros'] -
      //            obtenerPrecioEuros(values['CosteDolares'], rate?.CambioEuros, rate?.CambioDolares) ,
      PaginaWeb: values.PaginaWeb,
      Observaciones: values.Observaciones ?? '',
      ServicioFueraUE: values.ServicioFueraUE,
      TransporteAlojamiento: values.TransporteAlojamiento,
      ReemplazarNombreProveedor: values.ReemplazarNombreProveedor,
    };
    dispatch(startNewService(service, setSubmitting));
  };

  const handleCancel = () => {
    dispatch(startLogOutContentModal());
    dispatch(uiManageModalCollectionTypes());
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchemaSupplierService} onSubmit={handleSubmit}>
      {({ handleChange, errors, handleBlur, isSubmitting, touched, isValid, setFieldValue, values }) => (
        <Form>
          <Grid item style={{ padding: '2rem' }}>
            <Grid container direction="column">
              <Grid item classes={{ root: classes.container }}>
                <Typography variant="h1">Agregar Servicio</Typography>
              </Grid>
              {error && (
                <Box sx={{ mb: 3 }}>
                  <Alert style={{ backgroundColor: '#F3D1C7' }} severity="error">
                    {error}
                  </Alert>
                </Box>
              )}
              <FormControl
                fullWidth
                variant="outlined"
                style={{
                  marginBottom: '2rem',
                }}
                disabled={isSubmitting}
                onBlur={handleBlur}
                onChange={handleChange}
                error={touched.tipo_servicio && Boolean(errors.tipo_servicio)}
                helperText={touched.tipo_servicio && errors.tipo_servicio}>
                <InputLabel style={{ fontSize: '0.8em' }} id="select-label-exchange-rates">
                  Tipo de Servicio
                </InputLabel>

                <Select
                  style={{ fontSize: '0.8em' }}
                  name="tipo_servicio"
                  value={values.tipo_servicio}
                  label="Tipo de Servicio"
                  onChange={e => {
                    setFieldValue('tipo_servicio', e.target.value);
                    setServiceType(e.target.value);
                  }}>
                  <MenuItem style={{ fontSize: '0.7em' }} value={2}>
                    Parque
                  </MenuItem>
                  <MenuItem style={{ fontSize: '0.7em' }} value={1}>
                    Tour
                  </MenuItem>
                </Select>
              </FormControl>

              {!active && (
                <Autocomplete
                  style={{ fontSize: '0.8em' }}
                  name="proveedor"
                  autoHighlight
                  fullWidth
                  disablePortal
                  noOptionsText={`No hay proveedores`}
                  id="proveedor-autocomplete-exchange-rate"
                  renderInput={params => (
                    <TextField
                      {...params}
                      name="proveedor"
                      variant="outlined"
                      label="Proveedor"
                      placeholder="Busca..."
                      disabled={isSubmitting}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.proveedor && Boolean(errors.proveedor)}
                      helperText={touched.proveedor && errors.proveedor}
                      value={value}
                    />
                  )}
                  sx={{ marginBottom: '2rem' }}
                  options={suppliers.map(supplier => {
                    return { label: `${supplier.Nombre}`, value: supplier.PkProveedores };
                  })}
                  onChange={(e, selectedValue) => {
                    setFieldValue(
                      'proveedor',
                      selectedValue?.value !== null ? selectedValue?.value : initialValues.proveedor,
                    );
                    setValue(selectedValue?.value);
                    // Inicializar ServicioFueraUE, TransporteAlojamiento y ReemplazarNombreProveedor con el valor del proveedor
                    const selectedSupplier = suppliers.find(s => s.PkProveedores === selectedValue?.value);
                    if (selectedSupplier) {
                      setFieldValue('ServicioFueraUE', selectedSupplier.ProveedorFueraUE ?? false);
                      setFieldValue('TransporteAlojamiento', selectedSupplier.ProveedorFueraUE ?? false);
                      setFieldValue('ReemplazarNombreProveedor', selectedSupplier.ReemplazarNombreProveedor ?? false);
                      if (selectedSupplier.ReemplazarNombreProveedor) {
                        setShowReemplazarNombre(true);
                      } else {
                        setShowReemplazarNombre(false);
                      }
                    }
                  }}
                />
              )}
              <Grid item md={6} classes={{ root: classes.container }}>
                <SwitchMUI
                  label="Servicio de fuera UE"
                  name="ServicioFueraUE"
                  values={values}
                  setFieldValue={setFieldValue}
                  style={undefined}
                />
              </Grid>
              <Grid item md={6} classes={{ root: classes.container }}>
                <SwitchMUI
                  label="Incluye transporte o alojamiento"
                  name="TransporteAlojamiento"
                  values={values}
                  setFieldValue={setFieldValue}
                  style={undefined}
                />
              </Grid>

              <Grid xs={12} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Nombre"
                  size="small"
                  variant="outlined"
                  name="Nombre"
                  value={values.Nombre}
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BeachAccess />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.Nombre && Boolean(errors.Nombre)}
                  helperText={touched.Nombre && errors.Nombre}
                  disabled={isSubmitting}
                />
              </Grid>

              <Grid xs={12} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Alias"
                  size="small"
                  variant="outlined"
                  name="Alias"
                  value={values.Alias}
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BeachAccess />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.Alias && Boolean(errors.Alias)}
                  helperText={touched.Alias && errors.Alias}
                  disabled={isSubmitting}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid md={3} xs={6} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Coste Dolares"
                  size="small"
                  variant="outlined"
                  name="CosteDolares"
                  value={values.CosteDolares}
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BeachAccess />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.CosteDolares && Boolean(errors.CosteDolares)}
                  helperText={touched.CosteDolares && errors.CosteDolares}
                  disabled={isSubmitting}
                />
              </Grid>

              <Grid
                md={3}
                xs={6}
                item
                classes={{ root: classes.container }}
                style={{
                  display: errors.CosteDolares && touched.CosteDolares && 'none',
                }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Coste en Euros"
                  variant="outlined"
                  classes={{ root: classes.inputText }}
                  value={
                    rate ? obtenerPrecioEuros(values.CosteDolares, rate?.CambioEuros, rate?.CambioDolares) || 0 : ''
                  }
                  inputProps={{ readonly: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EuroOutlined />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                />
              </Grid>

              <Grid md={3} xs={6} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Precio Venta Euros"
                  size="small"
                  variant="outlined"
                  name="PrecioVentaEuros"
                  value={values.PrecioVentaEuros}
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Euro />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.PrecioVentaEuros && Boolean(errors.PrecioVentaEuros)}
                  helperText={touched.PrecioVentaEuros && errors.PrecioVentaEuros}
                  disabled={isSubmitting}
                />
              </Grid>

              <Grid md={3} xs={6} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Precio Venta Dolares"
                  size="small"
                  variant="outlined"
                  value={
                    rate
                      ? obtenerPrecioDolares(values['PrecioVentaEuros'], rate?.CambioEuros, rate?.CambioDolares) || 0
                      : ''
                  }
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BeachAccess />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
              </Grid>

              {values.PrecioVentaEuros &&
                values.PrecioVentaEuros >= calculateFromDollarsToEuro(rate, values.CosteDolares) && (
                  <>
                    <Grid md={3} xs={6} item classes={{ root: classes.container }}>
                      <TextField
                        fullWidth
                        label="Reserva Euros"
                        size="small"
                        variant="outlined"
                        value={
                          rate
                            ? values['PrecioVentaEuros'] -
                                obtenerPrecioEuros(values['CosteDolares'], rate?.CambioEuros, rate?.CambioDolares) || 0
                            : ''
                        }
                        classes={{ root: classes.inputText }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Euro />
                            </InputAdornment>
                          ),

                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        disabled={isSubmitting}
                      />
                    </Grid>

                    <Grid md={3} xs={6} item classes={{ root: classes.container }}>
                      <TextField
                        fullWidth
                        label="Reserva Dólares"
                        size="small"
                        variant="outlined"
                        value={
                          rate
                            ? obtenerPrecioDolares(values['PrecioVentaEuros'], rate?.CambioEuros, rate?.CambioEuros) -
                                values['CosteDolares'] || 0
                            : ''
                        }
                        classes={{ root: classes.inputText }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MonetizationOn />
                            </InputAdornment>
                          ),

                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        disabled={isSubmitting}
                      />
                    </Grid>
                  </>
                )}

              <Grid md={3} xs={6} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  size="small"
                  name="TasaDolares"
                  label="Tasa Dólares"
                  variant="outlined"
                  value={values.TasaDolares}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MonetizationOnOutlined />
                      </InputAdornment>
                    ),
                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.TasaDolares && Boolean(errors.TasaDolares)}
                  helperText={touched.TasaDolares && errors.TasaDolares}
                />
              </Grid>

              <Grid md={3} xs={6} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Tasa Euros"
                  size="small"
                  variant="outlined"
                  value={
                    rate ? obtenerPrecioEuros(values['TasaDolares'], rate?.CambioEuros, rate?.CambioDolares) || 0 : ''
                  }
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EuroOutlined />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Enlace Web"
                  size="small"
                  variant="outlined"
                  name="PaginaWeb"
                  value={values.PaginaWeb}
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BeachAccess />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.PaginaWeb && Boolean(errors.PaginaWeb)}
                  helperText={touched.PaginaWeb && errors.PaginaWeb}
                  disabled={isSubmitting}
                />
              </Grid>

              {showReemplazarNombre && (
                <Grid item md={6} classes={{ root: classes.container }}>
                  <SwitchMUI
                    label="Reemplazar nombre en Voucher"
                    name="ReemplazarNombreProveedor"
                    values={values}
                    setFieldValue={setFieldValue}
                    style={undefined}
                  />
                </Grid>
              )}

              <Grid xs={12} item classes={{ root: classes.container }}>
                <TextField
                  fullWidth
                  label="Observaciones"
                  size="small"
                  name="Observaciones"
                  variant="outlined"
                  classes={{ root: classes.inputText }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <RemoveRedEye />
                      </InputAdornment>
                    ),

                    classes: {
                      input: classes.resize,
                    },
                  }}
                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.Observaciones && Boolean(errors.Observaciones)}
                  helperText={touched.Observaciones && errors.Observaciones}
                  disabled={isSubmitting}
                  multiline
                  maxRows={10}
                  minRows={5}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: 2,
                }}>
                <Button
                  style={{
                    marginRight: '20px',
                    backgroundColor: '#F39868',
                    color: '#fff',
                    borderRadius: 7,
                    marginLeft: 10,
                  }}
                  onClick={handleCancel}>
                  <Typography style={{ fontWeight: 'bold' }}>Cancelar </Typography>
                </Button>

                <LoadingButton
                  loadingPosition="start"
                  variant="contained"
                  type="submit"
                  loading={isSubmitting}
                  disabled={!isValid}
                  style={{
                    backgroundColor: '#E5824F',
                  }}>
                  Agregar
                </LoadingButton>
              </Box>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
